import React from 'react';
import { Link } from 'react-router-dom';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="container not-found-container">
      <div className="not-found-content">
        <FaExclamationTriangle className="not-found-icon" />
        <h1>404</h1>
        <h2>Sidan hittades inte</h2>
        <p>Tyvärr kunde vi inte hitta sidan du söker.</p>
        <Link to="/" className="btn">
          <FaHome /> Tillbaka till startsidan
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 